import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useTicketAnchorProps } from "./TicketsProvider";

export function FinalCTA() {
  const { t } = useI18n();
  const ticketAnchor = useTicketAnchorProps();
  return (
    <section id="tickets" className="film-grain relative isolate overflow-hidden py-28 md:py-40">
      <div className="absolute inset-0 -z-10 bg-gradient-night" />
      <div className="absolute left-1/2 top-1/2 -z-10 h-[700px] w-[1000px] -translate-x-1/2 -translate-y-1/2 bg-glow opacity-80" />
      <div className="absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />

      <div className="mx-auto max-w-4xl px-5 text-center md:px-8">
        <p className="font-mono-cinema text-[10px] text-gold">{t.finalCta.eyebrow}</p>
        <h2 className="mt-7 font-display text-5xl font-medium leading-[0.98] md:text-7xl lg:text-[5.5rem]">
          {t.finalCta.title1}
          <span className="mt-2 block italic font-normal bg-gradient-to-r from-amber-glow via-gold to-amber-glow bg-clip-text text-transparent">
            {t.finalCta.title2}
          </span>
        </h2>
        <p className="mx-auto mt-7 max-w-xl text-balance text-base text-foreground/75 md:text-lg">
          {t.finalCta.body}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          {ticketAnchor && (
            <Button asChild variant="hero" size="xl">
              <a {...ticketAnchor}>
                {t.common.buyTickets} <ArrowRight className="h-4 w-4" />
              </a>
            </Button>
          )}
          <Button asChild variant="ghostLine" size="xl">
            <a href="#updates">{t.common.receiveProgram}</a>
          </Button>
        </div>
        <p className="mt-6 font-mono-cinema text-[10px] text-foreground/75">
          {t.finalCta.note}
        </p>
      </div>
    </section>
  );
}
